import { ContentLayout } from '../Layouts/ContentLayout/ContentLayout';
import { Paginator } from '@/components/Paginator/Paginator';
import { PageBody } from '@/components/Page/PageBody/PageBody';
import { AMPLITUDE_EVENTS } from '@/services/amplitudeService/amplitudeEvents';
import { PageFooter } from '@/components/Page/PageFooter/PageFooter';
import { keepPreviousData, useQuery, useQueryClient } from '@tanstack/react-query';
import { OpcoOrganizationsTable } from './ui/OpcoOrganizationsTable';
import { Drawer } from '@/components/Drawer/Drawer';
import { useState } from 'react';
import { amplitudeService } from '@/services/amplitudeService/amplitudeService';
import { Button } from '@/components/Button/Button';
import PlusIcon from '../../images/PlusIcon.svg?react';
import { useGetSearchParams } from '@/hooks/useGetSearchParams';
import { CreateOrganizationForm } from './ui/CreateOrganizationForm/CreateOrganizationForm';
import { getListData } from '@/helpers/helpers';
import { loadOrganizations } from '@/bundle/_Opco/api/api';

export const OpcoOrganizationsPage = () => {
  const queryClient = useQueryClient();
  const searchParams = useGetSearchParams();

  const [isOpen, setIsOpen] = useState(false);

  const { data, isPending } = useQuery({
    queryKey: ['load_organizations', searchParams],
    queryFn: () => loadOrganizations(searchParams),
    placeholderData: keepPreviousData,
  });

  const openCreateOrganizationForm = () => {
    setIsOpen(true);

    amplitudeService.logEvent(AMPLITUDE_EVENTS.CreateOrganizationRedirect);
  };

  const closeForm = () => {
    setIsOpen(false);
  };

  const modifyOrganizationSuccess = () => {
    setIsOpen(false);
    queryClient.invalidateQueries({ queryKey: ['load_organizations', searchParams] });
  };

  const { list, totalCount, hasPagination } = getListData(data?.body, searchParams);

  return (
    <ContentLayout
      title='Organizations'
      breadcrumbs='Organizations'
      subtitle='View the list of organizations created in the System.'
      headerAction={
        <Button width={220} iconPosition='left' icon={<PlusIcon />} onClick={openCreateOrganizationForm} mobileStretch>
          Create Organization
        </Button>
      }
    >
      <PageBody>
        <OpcoOrganizationsTable items={list} isLoading={isPending} />
      </PageBody>
      {hasPagination && (
        <PageFooter>
          <Paginator page={searchParams.page} limit={searchParams.limit} total={totalCount} />
        </PageFooter>
      )}

      <Drawer
        isOpen={isOpen}
        header='Create Organization'
        subHeader='Please provide information for the new organization.'
        onClose={closeForm}
      >
        <CreateOrganizationForm onSuccess={modifyOrganizationSuccess} onCancel={closeForm}></CreateOrganizationForm>
      </Drawer>
    </ContentLayout>
  );
};
